module.exports = __webpack_public_path__ + "static/media/logoProvincial.3c079cae.png";